import { defineCustomElement, getAttribute, getBooleanAttribute, getFirstSlotElement, isAttrEqual, isAttrTrue, NectaryElement, setClass, updateAttribute, updateBooleanAttribute } from '../utils';
const templateHTML = '<style>:host{display:block}#wrapper{display:flex;flex-direction:column;width:100%}#bottom,#top{display:flex;align-items:baseline}#top{height:24px;margin-bottom:2px}#top.empty{display:none}#additional,#invalid,#label,#optional{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}#label{font:var(--sinch-comp-field-font-label);color:var(--sinch-comp-field-color-default-label-initial)}#optional{flex:1;font:var(--sinch-comp-field-font-optional);color:var(--sinch-comp-field-color-default-optional-initial);text-align:right}#additional{flex:1;text-align:right;font:var(--sinch-comp-field-font-additional);color:var(--sinch-comp-field-color-default-additional-initial);line-height:20px;margin-top:2px}#additional:empty{display:none}#invalid{font:var(--sinch-comp-field-font-invalid);color:var(--sinch-comp-field-color-invalid-text-initial);line-height:20px;margin-top:2px}#invalid:empty{display:none}#tooltip{align-self:center;margin:0 8px;display:flex}#tooltip.empty{display:none}:host([disabled]) #label{color:var(--sinch-comp-field-color-disabled-label-initial)}:host([disabled]) #additional{color:var(--sinch-comp-field-color-disabled-additional-initial)}:host([disabled]) #optional{color:var(--sinch-comp-field-color-disabled-optional-initial)}</style><div id="wrapper"><div id="top"><label id="label" for="input"></label><div id="tooltip"><slot name="tooltip"></slot></div><span id="optional"></span></div><slot name="input"></slot><div id="bottom"><div id="invalid"></div><div id="additional"></div></div></div>';
const template = document.createElement('template');
template.innerHTML = templateHTML;
defineCustomElement('sinch-field', class extends NectaryElement {
  #$label;
  #$optionalText;
  #$additionalText;
  #$invalidText;
  #$inputSlot;
  #$tooltipWrapper;
  #$tooltipSlot;
  #controller = null;
  constructor() {
    super();
    const shadowRoot = this.attachShadow();
    shadowRoot.appendChild(template.content.cloneNode(true));
    this.topSection = shadowRoot.querySelector('#top');
    this.#$label = shadowRoot.querySelector('#label');
    this.#$optionalText = shadowRoot.querySelector('#optional');
    this.#$additionalText = shadowRoot.querySelector('#additional');
    this.#$invalidText = shadowRoot.querySelector('#invalid');
    this.#$inputSlot = shadowRoot.querySelector('slot[name="input"]');
    this.#$tooltipSlot = shadowRoot.querySelector('slot[name="tooltip"]');
    this.#$tooltipWrapper = shadowRoot.querySelector('#tooltip');
  }
  connectedCallback() {
    this.#controller = new AbortController();
    const {
      signal
    } = this.#controller;
    const options = {
      signal
    };
    this.shouldShowTopSection();
    this.#$label.addEventListener('click', this.#onLabelClick, options);
    this.#$tooltipSlot.addEventListener('slotchange', this.#onTooltipSlotChange, options);
  }
  disconnectedCallback() {
    this.#controller.abort();
    this.#controller = null;
  }
  static get observedAttributes() {
    return ['label', 'optionaltext', 'additionaltext', 'invalidtext', 'disabled'];
  }
  shouldShowTopSection() {
    const label = getAttribute(this, 'label');
    const optionaltext = getAttribute(this, 'optionaltext');
    setClass(this.topSection, 'empty', label === null && optionaltext === null);
  }
  attributeChangedCallback(name, oldVal, newVal) {
    switch (name) {
      case 'label':
        {
          this.#$label.textContent = newVal;
          break;
        }
      case 'optionaltext':
        {
          this.#$optionalText.textContent = newVal;
          break;
        }
      case 'additionaltext':
        {
          this.#$additionalText.textContent = newVal;
          break;
        }
      case 'invalidtext':
        {
          this.#$invalidText.textContent = newVal;
          break;
        }
      case 'disabled':
        {
          if (isAttrEqual(oldVal, newVal)) {
            break;
          }
          updateBooleanAttribute(this, name, isAttrTrue(newVal));
          break;
        }
    }
    this.shouldShowTopSection();
  }
  set label(value) {
    updateAttribute(this, 'label', value);
  }
  get label() {
    return getAttribute(this, 'label');
  }
  set optionalText(value) {
    updateAttribute(this, 'optionaltext', value);
  }
  get optionalText() {
    return getAttribute(this, 'optionaltext');
  }
  set additionalText(value) {
    updateAttribute(this, 'additionaltext', value);
  }
  get additionalText() {
    return getAttribute(this, 'additionaltext');
  }
  set invalidText(value) {
    updateAttribute(this, 'invalidtext', value);
  }
  get invalidText() {
    return getAttribute(this, 'invalidtext');
  }
  set disabled(isDisabled) {
    updateBooleanAttribute(this, 'disabled', isDisabled);
  }
  get disabled() {
    return getBooleanAttribute(this, 'disabled');
  }
  #onLabelClick = () => {
    getFirstSlotElement(this.#$inputSlot)?.focus?.();
  };
  #onTooltipSlotChange = () => {
    setClass(this.#$tooltipWrapper, 'empty', this.#$tooltipSlot.assignedElements().length === 0);
  };
});